export const appConfig = {
    totalQuiz: 5,        // Nombre de quiz par défaut
    correctAnswerThreshold : 10, // Nombre de bonnes réponses au quiz pour passer aux exercices
    totalExercises: 5   // Nombre d'exercices par défaut
  };
  